module.exports = __webpack_public_path__ + "img/vi_vn.fcabc5dc.png";